import { valoresData } from '@/mocks/nosotros-data';

export default function ValoresSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block text-xs md:text-sm font-semibold uppercase tracking-widest text-primary-600 mb-3">
              Principios
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">
              Nuestros Valores
            </h2>
          </div>

          {/* Values Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {valoresData.map((valor) => (
              <div
                key={valor.title}
                className="group rounded-2xl bg-background-100 border border-secondary-200/60 p-6 md:p-7 hover:border-primary-200/60 transition-all duration-300"
              >
                <div className="flex items-start gap-4">
                  <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-primary-50 text-primary-600 group-hover:bg-primary-100 group-hover:scale-110 transition-all duration-300 shrink-0">
                    <i className={`${valor.icon} text-xl`} />
                  </span>
                  <div>
                    <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2">
                      {valor.title}
                    </h3>
                    <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">
                      {valor.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}